export const amountFormat = (value, currency, position = 'p', decimals, decimalsChars, hideAmounts, separators) => {
	if (!value && value !== 0) return '-'

	/* Adding logic to default values */
	if (!decimalsChars) decimalsChars = 2
	if (!decimals && decimals !== false) decimals = true

	/* Separators default to the PT format used across the app, callers can override them */
	const thousandsSeparator = separators?.thousands ?? ' '
	const decimalSeparator = separators?.decimal ?? ','

	let stringValue = value.toString()

	if (!value.toString().includes('.')) stringValue = `${stringValue}.00`

	const splitedValue = stringValue.replace('.', ',').split(',')
	const decimalNumber = Number(`0.${splitedValue[1]}`).toFixed(decimals ? decimalsChars : 0)
	const formattedValue = `${splitedValue[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator)}${decimalSeparator}${decimalNumber.replace('0.', '')}`

	if (currency) {
		/* Fixing currency displayed when it's AKZ provided by mdw */
		if (currency.toLowerCase() === 'akz') currency = 'Kz'

		if (position === 's') {
			return (hideAmounts ? '***, 00' : formattedValue) + ' ' + currency
		} else {
			return currency + ' ' + (hideAmounts ? '***, 00' : formattedValue)
		}
	} else {
		return hideAmounts ? '***, 00' : formattedValue
	}
}

/** Separators used by the amount printed on the mdw generated card image, comma for
thousands and dot for decimals, so the balance we draw on the card visual matches it
*/
export const CARD_AMOUNT_SEPARATORS = { thousands: ',', decimal: '.' }

/** Receives value and currency to format an amount the same way the card image prints it
@value { string, number }
@currency { string }
@return { string }
*/
export const cardAmountFormat = (value, currency) => {
	return amountFormat(value, currency, 'p', undefined, undefined, undefined, CARD_AMOUNT_SEPARATORS)
}

/** Receives currency string for parsing if it's AKZ
@currency { string }
@return { string }
*/
export const currencyParser = currency => {
	return currency === 'AKZ' ? 'Kz' : currency
}

/** Receives maxValue and minValue strings, to compare and return if maxValue is above minValue
@maxValue { string }
@minValue { string }
@return { string }
*/
export const validateMaxAboveMinAmount = (maxValue, minValue) => {
	/* First we check length, if length is lower we know the value is in range */
	if (minValue.length < maxValue.length) return true
	/* If the length is the same we will need to check each position */
	else if (minValue.length === maxValue.length) {
		let numberIsInRange = true
		let i = 0

		while (numberIsInRange && i < minValue.length) {
			if (parseInt(minValue[i]) > parseInt(maxValue[i])) {
				numberIsInRange = false
			}
			i++
		}
		return numberIsInRange
	} else return false
}
